import React, { useMemo } from 'react';
import BaseSelectWithOptions from '../base-components/BaseSelectWithOptions';

function DesovaSelect({ ...props }) {
  const list = useMemo(() => [
    {
      id: 'Sim', value: true, label: 'Sim',
    }, {
      id: 'Não', value: false, label: 'Não',
    }
  ], []);

  return (
    <BaseSelectWithOptions
      list={list}
      {...props}
    />
  );
}

export default DesovaSelect;
